const Mutations = Object.freeze({
	SET_FILTERS: 'activityBuilder/activityFilters/SET_FILTERS',
	SET_FIELDS: 'activityBuilder/activityFilters/SET_FIELDS',
	SET_LOADING: 'activityBuilder/activityFilters/SET_LOADING',
});

export const Actions = Object.freeze({
	CLEAR: 'activityBuilder/activityFilters/CLEAR',
	LOAD: 'activityBuilder/activityFilters/LOAD',
	INSERT: 'activityBuilder/activityFilters/INSERT',
	UPDATE: 'activityBuilder/activityFilters/UPDATE',
});

export const Getters = Object.freeze({
	FILTERS: 'activityBuilder/activityFilters/FILTERS',
	FIELDS: 'activityBuilder/activityFilters/FIELDS',
});
import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/activityDataService';
export default {
	state: {
		filters: { ActivityId: null, LogicalOperator: 1, Filters: [] },
		fields: [],
		loading: false,
	},
	mutations: {
		[Mutations.SET_FILTERS](state, items) {
			if (items.length >= 1)
				state.filters = {
					ActivityId: items[0].ActivityId,
					Operator: items[0].LogicalOperator,
					Filters: items.map((x) => {
						return {
							FieldId: x.GridViewFieldId,
							Operator: x.Operator,
							Value: x.Value,
							Id: x.Id,
							IsDeleted: false,
						};
					}),
				};
			else
				state.filters = {
					ActivityId: null,
					LogicalOperator: 1,
					Filters: [],
				};
		},
		[Mutations.SET_FIELDS](state, items) {
			state.fields = items;
		},
		[Mutations.SET_LOADING](state, item) {
			state.loading = item;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_FILTERS, {
					ActivityId: null,
					LogicalOperator: 1,
					Filters: [],
				});
				commit(Mutations.SET_FIELDS, []);
				resolve();
			});
		},
		[Actions.LOAD]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				let promises = [
					dataService.getActivityFilters(id).then((resp) => {
						commit(Mutations.SET_FILTERS, resp.data);
					}),
					dataService
						.getGridViewFieldsByActivityId(id)
						.then((resp) => {
							commit(Mutations.SET_FIELDS, resp.data);
						}),
				];
				Promise.all(promises)
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.INSERT]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				dataService
					.insertActivityFilters(item)
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.UPDATE]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				dataService
					.updateActivityFilters(item)
					.then(() => {
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.FILTERS]: (state) => {
			return JSON.parse(JSON.stringify(state.filters));
		},
		[Getters.FIELDS]: (state) => {
			return JSON.parse(JSON.stringify(state.fields));
		},
	},
};
